"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetlistTriageLocations = exports.NetlistTriagePointerSchema = void 0;
const zod_1 = require("zod");
const ServiceLocation_1 = require("../ServiceLocations/ServiceLocation");
const BUILD_BLOB_SOURCE = 'userdata';
exports.NetlistTriagePointerSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    cadTool: zod_1.z.string().optional(),
    workflowId: zod_1.z.string(),
    uploadsPrefix: zod_1.z.string(),
    validationResultKey: zod_1.z.string(),
    bundleKey: zod_1.z.string().optional(),
    bundleUnavailableReason: zod_1.z.string().optional(),
    pipelineOpsUrl: zod_1.z.string().optional(),
});
class NetlistTriageLocations {
    static uploadsPrefix(organizationId, projectId, buildId) {
        return (0, ServiceLocation_1.createLocationString)(BUILD_BLOB_SOURCE, `${organizationId}/projects/${projectId}/builds/${buildId}/uploads/`);
    }
    static validationResultKey(organizationId, projectId, buildId) {
        return (0, ServiceLocation_1.createLocationString)(BUILD_BLOB_SOURCE, `${organizationId}/projects/${projectId}/builds/${buildId}/netlistValidation.json`);
    }
    static bundleKey(organizationId, projectId, buildId, runId) {
        return (0, ServiceLocation_1.createLocationString)(BUILD_BLOB_SOURCE, `${organizationId}/projects/${projectId}/builds/${buildId}/netlist-generation/triage-${runId}.tar.gz`);
    }
    static pipelineOpsUrl(appBaseUrl, buildId) {
        return `${appBaseUrl.replace(/\/+$/, '')}/tools/admin/pipeline-ops?buildId=${encodeURIComponent(buildId)}`;
    }
}
exports.NetlistTriageLocations = NetlistTriageLocations;
//# sourceMappingURL=netlist-triage.js.map